"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineDatePicker = void 0;
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const pickers_1 = require("@material-ui/pickers");
const StyledGrid = (0, styled_components_1.default)(core_1.Grid) `
  display: flex;
  flex-direction: column;
`;
const InlineDatePicker = props => {
    const { label, name, format, asInnerLabel, placeholder, birthdate, picker, setDateHours, disabled, clearable, autoCloseOnSelect } = props;
    let { grid } = props;
    const formik = (0, formik_1.useFormikContext)();
    const [field, meta, { setValue, setError, setTouched }] = (0, formik_1.useField)(props);
    const [lastSubmitCount, setLastSubmitCount] = (0, react_1.useState)(formik.submitCount);
    const [previousValue, setPreviousValue] = (0, react_1.useState)(meta.initialValue);
    const eventRef = (0, react_1.useRef)();
    if (!grid) {
        // default field to expand entire width of form
        grid = { xs: 12 };
    }
    // fix date input format
    if (field.value &&
        typeof field.value === 'string' &&
        field.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // fix date only fields (otherwise date offset by 1)
        field.value = `${field.value}T00:00:00`;
    }
    // important: value cannot be empty string
    const value = !isNaN(new Date(field.value).getTime()) ? field.value : null;
    (0, react_1.useEffect)(() => {
        // update previous value if initial value changes
        setPreviousValue(meta.initialValue);
    }, [meta.initialValue]);
    (0, react_1.useEffect)(() => {
        if (!formik.isSubmitting && lastSubmitCount !== formik.submitCount) {
            // form finished submitting so set current value to previous value
            setPreviousValue(meta.value);
            setLastSubmitCount(formik.submitCount);
        }
    }, [formik.isSubmitting, formik.submitCount, lastSubmitCount, meta.value]);
    const handleCancel = () => {
        setTouched(false);
        setValue(previousValue);
    };
    const handleChange = (date) => {
        // console.log('handleChange', date);
        if (date && !isNaN(date.getTime())) {
            if (setDateHours) {
                date === null || date === void 0 ? void 0 : date.setHours(23, 59, 59);
            }
            setTouched(true);
            // save date in ISO string format
            setValue(date.toISOString());
            if (eventRef.current) {
                // tell formik the field changed
                eventRef.current.target.value = date.toISOString();
                field.onChange(eventRef.current);
            }
        }
        else if (date === null) {
            setTouched(true);
            setValue(date);
            if (eventRef.current) {
                // tell formik the field changed
                eventRef.current.target.value = date;
                field.onChange(eventRef.current);
            }
        }
    };
    const datePickerProps = (0, react_1.useMemo)(() => {
        const pickerProps = Object.assign({}, picker);
        if (birthdate) {
            pickerProps.disableFuture = true;
            pickerProps.openTo = 'year';
            pickerProps.views = ['year', 'month', 'date'];
        }
        if (clearable) {
            pickerProps.InputProps = {
                endAdornment: (react_1.default.createElement(core_1.IconButton, { onClick: () => {
                        handleChange(null);
                        formik.submitForm();
                    } },
                    react_1.default.createElement(icons_1.Clear, null)))
            };
        }
        return pickerProps;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [picker, clearable, birthdate, handleChange]);
    return (react_1.default.createElement(StyledGrid, Object.assign({ item: true, className: 'inline-text-field' }, grid),
        !asInnerLabel && (react_1.default.createElement(core_1.Typography, { variant: 'h5', gutterBottom: true }, label)),
        react_1.default.createElement(pickers_1.KeyboardDatePicker
        // autoOk
        , Object.assign({ 
            // autoOk
            name: name, label: asInnerLabel ? label : undefined, disabled: disabled, variant: 'inline', inputVariant: 'outlined', placeholder: placeholder, format: format || 'MM/dd/yyyy', InputAdornmentProps: { position: clearable ? 'start' : 'end' }, error: meta.touched && Boolean(meta.error), helperText: meta.error, value: value, autoOk: Boolean(autoCloseOnSelect), onChange: date => handleChange(date), onAccept: date => {
                // save when selecting from popup dialog
                handleChange(date);
                formik.submitForm();
            }, onError: error => {
                if (error !== meta.error) {
                    setError(error);
                }
            }, onKeyDown: event => {
                switch (event.key) {
                    case 'Escape':
                        return handleCancel();
                }
            }, onFocus: event => {
                // persist event to use for field.onChange()
                event.persist();
                eventRef.current = event;
            }, onBlur: () => {
                // save on field blur
                setTouched(true);
                formik.submitForm();
            } }, datePickerProps))));
};
exports.InlineDatePicker = InlineDatePicker;
exports.default = exports.InlineDatePicker;
//# sourceMappingURL=InlineDatePicker.js.map